import axiosAuth from '../../axiosMain';

async function index(id) {
  let response = await axiosAuth.get('/category_consumption/stats/' + id);
  return response.data;
}

async function count(id) {
  let response = await axiosAuth.get('/category_consumption/invoices/count/' + id);
  return response.data.file_count;
}

export default {
  index,
  count,
};
